import axios from "axios";
import { toast } from "react-toastify";

// Base URL from env
const goorm = process.env.REACT_APP_BASE_URL_CBMS;

// Create an axios instance
const apiInstance = axios.create({
  baseURL: goorm,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    "Access-Control-Allow-Origin": "*",
  },
});

// ✅ Add request interceptor to include token if available
apiInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Add response interceptor to handle 401/403
apiInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      toast.error(error.response.data.msg);
      localStorage.removeItem("token");
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

// ✅ Exported API call function
export const apicall = async (
  path,
  method,
  data,
  options = {}
) => {
  return await apiInstance({
    method,
    url: path,
    data,
    ...options,
  });
};
